import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {DisclaimerService} from '../../../Services/disclaimer.service';
import {Disclaimer} from '../../../Models/Disclaimer';
import {Helper} from '../../../../helpers/helper.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-manage-dealer-points',
  templateUrl: './manage-disclaimer.component.html',
  styleUrls: ['./manage-disclaimer.component.scss']
})
export class ManageDisclaimerComponent implements OnInit {
  public modules = {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
      ['blockquote', 'code-block'],

      [{'header': 1}, {'header': 2}],               // custom button values
      [{'list': 'ordered'}, {'list': 'bullet'}],
      [{'script': 'sub'}, {'script': 'super'}],      // superscript/subscript
      [{'indent': '-1'}, {'indent': '+1'}],          // outdent/indent
      [{'direction': 'rtl'}],                         // text direction

      [{'size': ['small', false, 'large', 'huge']}],  // custom dropdown
      [{'header': [1, 2, 3, 4, 5, 6, false]}],

      [{'color': []}, {'background': []}],          // dropdown with defaults from theme
      [{'font': []}],
      [{'align': []}],

      ['clean'],                                         // remove formatting button

      ['link']                         // link and image, video
    ]
  };

  public disclaimer = new Disclaimer();
  public isEdit = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private disclaimerService: DisclaimerService,
    private helper: Helper,
    private translate: TranslateService
  ) {
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      if (Helper.isDefined(params['id'])) {
        this.isEdit = true;
        this.disclaimerService.showDisclaimer(params['id']).subscribe(res => {
          this.disclaimer = res;
        });
      }
    });
  }

  backToOverview() {
    this.router.navigateByUrl('/back-office/disclaimer/overview');
  }

  updateDisclaimer() {
    const id = this.disclaimer.id;
    delete this.disclaimer.id;
    this.disclaimerService.updateDisclaimer(this.disclaimer, id).subscribe( res => {
      this.helper.popMessageDialog(
        this.translate.instant('global.success_message.title'),
        this.translate.instant('global.success_message.description'),
        'success',
        false
      );
    });
  }

  createDisclaimer() {
    this.disclaimerService.createDisclaimer(this.disclaimer).subscribe( res => {
      this.helper.popMessageDialog(
        this.translate.instant('global.success_message.title'),
        this.translate.instant('global.success_message.description'),
        'success',
        false
      );
    });
  }

  saveDisclaimer() {
    if (this.disclaimer.id) {
      this.updateDisclaimer();
    } else {
      this.createDisclaimer();
    }
    this.router.navigateByUrl('/back-office/disclaimer/overview');
  }
}
